import { FontIcon } from '@brandfolder/react';
import classnames from 'classnames';
import { decode } from 'html-entities';
import React, { FunctionComponent } from 'react';
import { BrowserRouter, Routes, Route, NavLink } from 'react-router-dom';

import { UserGroupsCreate } from './UserGroupsCreate';
import { UserGroupsEdit } from './UserGroupsEdit';
import { BulkManagementLink } from '../shared';

import classes from './styles/user-groups.module.scss';

interface UserGroupsProps {
  enabledLinks: BulkManagementLink[];
  organizationKey: string;
}

export const UserGroups: FunctionComponent<UserGroupsProps> = (props) => {
  const { enabledLinks, organizationKey } = props;

  const isTest = process.env.NODE_ENV === 'test';
  const base = isTest ? '' : `/${BFG.resource.slug}/bulk_management`;
  const path = isTest ? '/' : `${base}/user_groups`;

  return (
    <BrowserRouter basename="/">
      <main className={classes.main}>
        <nav className={classes.nav}>
          <a
            className={classnames(classes.navLink, classes.backLink)}
            href={`/${BFG.resource.slug}`}
          >
            {bfTranslate('Return to')} {decode(BFG.resource.name)}
          </a>

          {enabledLinks.map((link) => {
            const icon = (
              <FontIcon
                className={classnames(classes.icon, `bff-${link.icon}`)}
                icon={link.icon}
              />
            );

            if (link.href.includes('user_groups')) {
              return (
                <NavLink key={link.id} className={classes.navLink} to={link.href}>
                  {icon}
                  {link.title}
                </NavLink>
              );
            }

            return (
              <a key={link.id} className={classes.navLink} href={`${base}#${link.href}`}>
                {icon}
                {link.title}
              </a>
            );
          })}
        </nav>
        <div className={classes.content}>
          <Routes>
            <Route path={path}>
              <Route element={<UserGroupsCreate organizationKey={organizationKey} />} index />
              <Route element={<UserGroupsEdit />} path=":userGroupKey" />
            </Route>
          </Routes>
        </div>
      </main>
    </BrowserRouter>
  );
};
